import Vue from 'vue';
import VueRouter from 'vue-router';
import Layout from '@/layout/Index.vue';
import Index from '../views/Index.vue';
Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Index',
        component: Index,
        redirect: '/index'
    },
    {
        path: '/loyout',
        name: 'Loyout',
        component: Layout,
        redirect: '/index',
        children: [
            {
                path: '/index',
                name: 'Index',
                component: Index
            },
            {
                path: '/social/job',
                name: 'Social',
                component: () => import(/* webpackChunkName: "Job" */ '../views/PC/Job.vue')
            },
            {
                path: '/worker/job',
                name: 'Worker',
                component: () => import(/* webpackChunkName: "Job" */ '../views/PC/Job.vue')
            },
            {
                path: '/campus/job',
                name: 'Campus',
                component: () => import(/* webpackChunkName: "Job" */ '../views/PC/Job.vue')
            },
            {
                path: '/job/:type',
                name: 'Job',
                component: () => import(/* webpackChunkName: "Job" */ '../views/PC/Job.vue')
            },
            {
                path: '/post/:id',
                name: 'Post',
                component: () => import(/* webpackChunkName: "Post" */ '../views/PC/PostDetail.vue')
            },
            {
                path: '/post/:id/apply',
                name: 'Apply',
                component: () => import(/* webpackChunkName: "Apply" */ '../views/PC/PostApply.vue')
            },

            {
                path: '/recommendjob',
                name: 'RecommendJob',
                component: () => import(/* webpackChunkName: "MobileRecommendJob" */ '../views/PC/RecommendJob.vue')
            },
            {
                path: '/recommendpost/:id',
                name: 'RecommendPost',
                component: () => import(/* webpackChunkName: "MobileRecommendPost" */ '../views/PC/RecommendPost.vue')
            },
            {
                path: '/recommendpost',
                name: 'RecommendPostNull',
                redirect: '/m/recommendjob'
            },
            {
                path: '/recommendedjob',
                name: 'JobAll',
                meta: { hiddenAll: true },
                component: () => import(/* webpackChunkName: "Job" */ '../views/PC/Job.vue')
            },
            {
                path: '/widely',
                name: 'Widely',
                component: () => import(/* webpackChunkName: "Widely" */ '../views/PC/Widely.vue')
            }
        ]
    },
    {
        path: '/m/index',
        redirect: '/m/404'
    },
    {
        path: '/m/social/job',
        name: 'MobileSocial',
        component: () => import(/* webpackChunkName: "MobileJob" */ '../views/mobile/Job.vue')
    },
    {
        path: '/m/worker/job',
        name: 'MobileWorker',
        component: () => import(/* webpackChunkName: "MobileJob" */ '../views/mobile/Job.vue')
    },
    {
        path: '/m/campus/job',
        name: 'MobileCampus',
        component: () => import(/* webpackChunkName: "MobileJob" */ '../views/mobile/Job.vue')
    },
    {
        path: '/m/job/:type',
        name: 'MobileJob',
        component: () => import(/* webpackChunkName: "MobileJob" */ '../views/mobile/Job.vue')
    },
    {
        path: '/m/recommendedjob',
        name: 'MobileJobAll',
        meta: { hiddenAll: true },
        component: () => import(/* webpackChunkName: "MobileJob" */ '../views/mobile/Job.vue')
    },
    {
        path: '/m/widely',
        name: 'MobileWidely',
        component: () => import(/* webpackChunkName: "MobileWidely" */ '../views/mobile/Widely.vue')
    },
    {
        path: '/m/post/:id',
        name: 'MobilePost',
        component: () => import(/* webpackChunkName: "MobilePost" */ '../views/mobile/PostDetail.vue')
    },
    {
        path: '/m/post/:id/apply',
        name: 'MobileApply',
        component: () => import(/* webpackChunkName: "MobileApply" */ '../views/mobile/PostApply.vue')
    },
    {
        path: '/recommendindex',
        name: 'RecommendIndex',
        component: () => import(/* webpackChunkName: "MobileRecommendJob" */ '../views/PC/RecommendIndex.vue')
    },
    {
        path: '/m/recommendindex',
        name: 'MobileRecommendIndex',
        component: () => import(/* webpackChunkName: "MobileRecommendJob" */ '../views/mobile/RecommendIndex.vue')
    },
    {
        path: '/m/recommendjob',
        name: 'MobileRecommendJob',
        component: () => import(/* webpackChunkName: "MobileRecommendJob" */ '../views/mobile/RecommendJob.vue')
    },
    {
        path: '/m/recommendpost/:id',
        name: 'MobileRecommendPost',
        component: () => import(/* webpackChunkName: "MobileRecommendPost" */ '../views/mobile/RecommendPost.vue')
    },
    {
        path: '/m/recommendpost',
        name: 'MobileRecommendPostNull',
        redirect: '/m/recommendjob'
    },
    {
        path: '/m/404',
        name: 'ErrorPage',
        component: () => import(/* webpackChunkName: "404" */ '../views/404.vue')
    },
    {
        path: '/404',
        name: 'ErrorPage',
        component: () => import(/* webpackChunkName: "404" */ '../views/404.vue')
    },
    {
        path: '*',
        redirect: '/index'
    }
];

const router = new VueRouter({
    mode: 'history',
    routes
});

// router.beforeEach((to, from, next) => {
//     console.log(to);
//     console.log(from);
//     next();
// });

export default router;
